'use client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactElement, ReactNode, useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';

import BannerCarouselDots from './BannerCarouselDots';
import BannerCarouselPaging from './BannerCarouselPaging';

import './style.css';

export interface BannerCarouselProps {
  children: ReactNode | ReactElement[];
}

const BannerCarousel = ({ children }: BannerCarouselProps) => {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const sliderRef = useRef<Slider | null>(null);

  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    initialSlide: 0,
    pauseOnHover: false,
    appendDots: dots => (
      <BannerCarouselDots
        dots={dots}
        goBack={() => {
          sliderRef.current?.slickGoTo(activeSlide + 1);
        }}
        goNext={() => {
          sliderRef.current?.slickGoTo(activeSlide - 1);
        }}
      />
    ),
    customPaging: i => (
      <BannerCarouselPaging
        key={i}
        index={i}
        activeSlide={activeSlide}
        onSlideChange={async currentSlide => {
          sliderRef.current?.slickGoTo(currentSlide);
          setActiveSlide(currentSlide);
        }}
      />
    ),
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setActiveSlide(nextSlide);
    },
  };

  return (
    <div className="v2-w-[100%]">
      <Slider {...settings} ref={sliderRef} className="banner-slider v2-relative">
        {children}
      </Slider>
    </div>
  );
};

export default BannerCarousel;
